import actions from "./actions";
import { call, put, takeLatest, fork } from "redux-saga/effects";
import {
  EXCHANGE_CODE,
  OTP_LOG,
  REQUEST_GIGYA,
  REQUEST_LOGIN,
  REQUEST_OTP,
  TOPUP_MOBILE,
  UPDATE_USER_INFO,
  VALIDATE_CAMPAIGN,
  VALIDATE_CODE,
  VERIFY_OTP,
  CHECK_TRANSACTION_ID,
  GENERATE_TRANSACTION_ID,
  CHECK_PHONE_NUMBER,
  RECEIVED_REPORT,
} from "./constants";
import {
  checkPhoneNumberApi,
  checkTransactionIdApi,
  generateTransactionIdApi,
  OTPLogApi,
  receivedReportApi,
  requestGigyaApi,
  requestLoginApi,
  requestOTPApi,
  updateUserInfoApi,
  validateCampaignApi,
  validateCodeApi,
  verifyOTPApi,
} from "api/home";

export function* validateCodeSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(validateCodeApi, payload);
    yield put(actions.VALIDATE_CODE.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.VALIDATE_CODE.failure(err));
  }
}

export function* validateCampaignSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(validateCampaignApi, payload);
    yield put(actions.VALIDATE_CAMPAIGN.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.VALIDATE_CAMPAIGN.failure(err));
  }
}

export function* requestOTPSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(requestOTPApi, payload);
    yield put(actions.REQUEST_OTP.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.REQUEST_OTP.failure(err));
  }
}

export function* OTPLogSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(OTPLogApi, payload);
    yield put(actions.OTP_LOG.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.OTP_LOG.failure(err));
  }
}

export function* verifyOTPSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(verifyOTPApi, payload);
    yield put(actions.VERIFY_OTP.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.VERIFY_OTP.failure(err));
  }
}

export function* requestLoginSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(requestLoginApi, payload);
    yield put(actions.REQUEST_LOGIN.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.REQUEST_LOGIN.failure(err));
  }
}

export function* updateUserInfoSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(updateUserInfoApi, payload);
    yield put(actions.UPDATE_USER_INFO.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.UPDATE_USER_INFO.failure(err));
  }
}

export function* requestGigyaSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(requestGigyaApi, payload);
    yield put(actions.REQUEST_GIGYA.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.REQUEST_GIGYA.failure(err));
  }
}

//new
export function* checkTransactionIdSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(checkTransactionIdApi, payload);
    yield put(actions.CHECK_TRANSACTION_ID.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err?.data);
    }
    yield put(actions.CHECK_TRANSACTION_ID.failure(err));
  }
}
export function* generateTransactionIdSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(generateTransactionIdApi, payload);
    yield put(actions.GENERATE_TRANSACTION_ID.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GENERATE_TRANSACTION_ID.failure(err));
  }
}
export function* checkPhoneNumberSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(checkPhoneNumberApi, payload);
    yield put(actions.CHECK_PHONE_NUMBER.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err?.data);
    }
    yield put(actions.CHECK_PHONE_NUMBER.failure(err));
  }
}
export function* receivedReportSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(receivedReportApi, payload);
    yield put(actions.RECEIVED_REPORT.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.RECEIVED_REPORT.failure(err));
  }
}
function* watchCommon() {
  yield takeLatest(VALIDATE_CODE.request, validateCodeSaga);
  yield takeLatest(VALIDATE_CAMPAIGN.request, validateCampaignSaga);
  yield takeLatest(REQUEST_OTP.request, requestOTPSaga);
  yield takeLatest(OTP_LOG.request, OTPLogSaga);
  yield takeLatest(VERIFY_OTP.request, verifyOTPSaga);
  yield takeLatest(REQUEST_LOGIN.request, requestLoginSaga);
  yield takeLatest(UPDATE_USER_INFO.request, updateUserInfoSaga);
  yield takeLatest(REQUEST_GIGYA.request, requestGigyaSaga);
  yield takeLatest(CHECK_TRANSACTION_ID.request, checkTransactionIdSaga);
  yield takeLatest(GENERATE_TRANSACTION_ID.request, generateTransactionIdSaga);
  yield takeLatest(CHECK_PHONE_NUMBER.request, checkPhoneNumberSaga);
  yield takeLatest(RECEIVED_REPORT.request, receivedReportSaga);
}

export default function* rootChild() {
  yield fork(watchCommon);
}
